/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import _ from 'lodash';
import { Module, ActionContext } from 'vuex';
import RootStateType from './types';

/**
 * 生成mutations的TypeName，在执行commit修改属性的时候使用：
 * this.$store.commit(MUTATION_TYPE('username'), 'H5Developer')
 */
export const MUTATION_TYPE = (name: string): string => `UPDATE_${name.replace(/(\w)(?=[A-Z])/g, '$1_').toUpperCase()}`;

export const RESET_STATE_TYPE = '$resetState';
export const UPDATE_STATE_TYPE = '$updateState';

// 为所有state属性自动生成更新mutations
const generateMutations = <T>(
  storeModule: Module<T, RootStateType>,
): Module<T, RootStateType> => {
  const stateNames = Object.keys(storeModule.state || {});

  // 在触发RESET的时候重置数据
  storeModule.initState = _.clone(storeModule.state);

  storeModule.mutations = storeModule.mutations || {};
  storeModule.actions = storeModule.actions || {};

  stateNames.forEach((name) => {
    // 设置属性的[UPDATE]方法
    const mutationName = MUTATION_TYPE(name);

    storeModule.mutations = storeModule.mutations || {};

    if (!storeModule.mutations[mutationName]) {
      storeModule.mutations[mutationName] = ((attrName) => (
        state: T,
        payload: Dictionary,
      ) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state as any)[attrName] = payload[attrName];
      })(name);
    }
  });

  // 设置模块的RESET方法重置数据
  storeModule.mutations.RESET = (state: unknown) => {
    // @ts-ignore
    Object.assign(state, storeModule.initState);
  };

  // 重置数据
  storeModule.actions[RESET_STATE_TYPE] = (
    context: ActionContext<unknown, RootStateType>,
  ) => {
    context.commit({
      type: 'RESET',
    });
  };

  // 快速批量更新state属性
  storeModule.actions[UPDATE_STATE_TYPE] = (
    context: ActionContext<unknown, RootStateType>,
    payload: Dictionary,
  ) => {
    if (_.isObjectLike(payload)) {
      Object.keys(payload).map((name) => {
        context.commit({
          type: MUTATION_TYPE(name),
          [name]: payload[name],
        });
      });
    }
  };

  return storeModule;
};

export default generateMutations;
